module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_waso_location-97e6209c0dd2a926ab827ece950dcbe9.webp";